import { useContext } from 'react';
import { AuthContext } from '../auth/AuthContext';

// Return the authentication context value directly without decoding JWT tokens
function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
